import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { setElectronSmsNotificationContext } from "../../utils/electron/electronSmsNotificationContext";

export function useElectronSmsNotificationBridge(enabled = true): void {
  const { selectedDid } = useSelector((state: RootState) => state.smsDids);
  const { selectedConversation } = useSelector((state: RootState) => state.conversation);

  useEffect(() => {
    if (!enabled) return;
    setElectronSmsNotificationContext({
      activeDid: selectedDid,
      activeConversationId: selectedConversation?.conversation_id ?? null,
    });
  }, [enabled, selectedDid, selectedConversation]);
}
